export enum BillingsPlanEntryTaxiDriverRecalculateRequestContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverRecalculateRequestBonusContribution =
  | BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContribution =
  | BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateRequestContribution =
  | BillingsPlanEntryTaxiDriverRecalculateRequestBonusContribution
  | BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContribution
  | BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverRecalculateRequestBody = {
  billingNodes: BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverRecalculateRequestContribution[];
};

type BillingsPlanEntryTaxiDriverRecalculateRequest = {
  planEntryId: string;
  billingNodes: BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverRecalculateRequestContribution[];
};

export default BillingsPlanEntryTaxiDriverRecalculateRequest;
